export const FIELD_TYPE_DATE = 'FIELD_TYPE_DATE';
export const FIELD_TYPE_DOUBLE = 'FIELD_TYPE_DOUBLE';
export const FIELD_TYPE_FREEFORM = 'FIELD_TYPE_FREEFORM';
export const FIELD_TYPE_LABEL = 'FIELD_TYPE_LABEL';
export const FIELD_TYPE_SELECT = 'FIELD_TYPE_SELECT';
export const FIELD_TYPE_STATIC = 'FIELD_TYPE_STATIC';
export const FIELD_TYPE_TEXTAREA = 'FIELD_TYPE_TEXTAREA';
